import React, {useState} from 'react';
import { Box, Stack, CircularProgress } from '@mui/material';
import TopBar from '../../../../../../../../component/TopBar';
import ActiveBar from '../../../../../../../../component/PolicyNavbarUpdated';
import BtnSecondary from "../../../../../../../../component/SecondaryButton";
import BtnPrimary from "../../../../../../../../component/PrimaryButton";
import ErrorMsg from '../../../../../../../../component/ErrorMsg';
import { useLocation, useNavigate } from 'react-router';
import FormField from '../../../../../../../../component/Formfield';
import DateField from '../../../../../../../../component/DateField';
import { WizardCard, FormSection, WizardActions } from '../../../../../../../../component/wizard';
import { updateShiftRotation } from '../../../../../../../../services/shiftRotation';
import { useNotify } from '../../../../../../../../component/NotificationProvider';

const RotationFrequency = () => {
    const [apiCall,setApiCall]=useState(false);
    const navigate = useNavigate();
    const notify = useNotify();
    const {state} = useLocation();
    const rotationId = state?.rotationId;
    const [shiftData,setShiftData] = useState({
          rotationType:"Weekly",
          rotationFrequency:"",
          freqType:"Weeks",
          startDate:null
    });
    const [startDateDialogOpen, setStartDateDialogOpen] = useState(false);
    const [validationErrors, setValidationErrors] = useState({rotationType:"", rotationFrequency:"", startDate:""});
    const [error,setError]=useState("");

    const getFrequencyType = (frequency) => frequency === "Weekly" ? "Weeks" : "Months";

    const handleNextClick = async() => {
        const errors ={};
        if (!shiftData.rotationType) errors.rotationType="Rotation Type is required"
        if (!shiftData.rotationFrequency) errors.rotationFrequency="Rotation Frequency is required"
        if (!shiftData.startDate) errors.startDate="Start date is required"

        if (Object.keys(errors).length > 0) {
          setValidationErrors(errors);
          return;
        }
        if (!rotationId) {
          notify.error("Missing rotation — start again from step 1");
          return;
        }

        setApiCall(true);
        try {
            const res = await updateShiftRotation(rotationId, {
              rotationType: shiftData.rotationType,
              rotationFrequency: Number(shiftData.rotationFrequency),
              startDate: shiftData.startDate,
            });
            if (res.success) {
              notify.success("Rotation frequency saved");
              navigate("/app/shift-rotation/new/assign-rotation",{state:{rotationId}});
            } else {
              setError(res.message);
              notify.error(res?.message || "Could not save rotation frequency");
            }
        } catch (error) {
            setError(error?.message || "Something went wrong");
            notify.error(error?.message || "Something went wrong");
        } finally {
            setApiCall(false);
        }
    };

    const handleChange = (field, value) => {
      setShiftData(prevState => ({...prevState, [field]: value}));
      setValidationErrors(prevState => ({...prevState, [field]: ""}));
      setError("");
    };

  return (
    <Box sx={{width:"100%"}}>
      <TopBar MainHeading={"Shift Rotation"}
        breadcrumbs={[{ label: "Shift Rotation", href: "" }, { label: "Frequency", href: "" }]} />
      <WizardCard>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar page="shift-rotation" active={["Shift", "Frequency"]} />
                <BtnSecondary to={"/app/shift-rotation/new/rotation-details"} sx={{ borderRadius: "8px" }}>Back</BtnSecondary>
            </Stack>
            <FormSection title="Rotation cadence" description="How often employees advance to the next shift, and when the rotation begins.">
                        <FormField
                            label="Rotation Type"
                            type="select"
                            value={shiftData.rotationType}
                            validation={validationErrors.rotationType}
                            options={["Weekly","Monthly"]}
                            onChange={(e) => {
                                        handleChange('rotationType', e.target.value)
                                        handleChange('freqType', getFrequencyType(e.target.value))
                                    }}
                        />
                        <FormField
                            label="Rotation Frequency"
                            type="text"
                            value={shiftData?.rotationFrequency}
                            validation={validationErrors?.rotationFrequency}
                            placeholder={`no. of ${shiftData?.freqType?.toLowerCase()} before rotation occurs`}
                            onChange={(e) => handleChange('rotationFrequency', e.target.value)}
                            endAdornment={shiftData?.freqType}
                        />
                        <DateField
                            label="Shift rotation start date"
                            value={shiftData.startDate}
                            isDialogOpen={startDateDialogOpen}
                            validation={validationErrors.startDate}
                            openDialog={() => setStartDateDialogOpen(true)}
                            closeDialog={() => setStartDateDialogOpen(false)}
                            onSelect={(date) => {
                                    handleChange('startDate', date)
                                    setStartDateDialogOpen(false)
                                    }}
                        />
            </FormSection>
            <ErrorMsg>{error}</ErrorMsg>
            <WizardActions>
                <BtnPrimary
                    onClick={handleNextClick}
                    sx={{ height: "3rem", px: "2.5rem", borderRadius: "10px" }}
                    disabled={apiCall}
                >
                    {apiCall?<CircularProgress size={"1.25rem"} />:"Next"}
                </BtnPrimary>
            </WizardActions>
      </WizardCard>
    </Box>
  )
}

export default RotationFrequency;
